<template>
  <div>
    <h6>
      <CoordinationExplanation />
      Munkaterület átadás típusa:
    </h6>
    <div class="row">
      <div class="col-6 text-center">
        <span class="d-block mb-2">kizárólagos használatra</span>
        <input
          type="radio"
          class="form-check-input"
          v-model="coordination"
          :value="1"
          id="coordination_radio_input_1"
        />
      </div>
      <div class="col-6 text-center">
        <span class="d-block mb-2"
          >részleges használatra, ahol az összehangolást végzi</span
        >
        <div class="row my-2">
          <div class="col-6">
            <input
              type="radio"
              class="form-check-input"
              v-model="coordination"
              :value="2"
              id="coordination_radio_input_2"
            />
            <label for="coordination_radio_input_2" class="form-check-label">
              DDC</label
            >
          </div>
          <div class="col-6">
            <input
              type="radio"
              class="form-check-input"
              v-model="coordination"
              :value="3"
              id="coordination_radio_input_3"
            />
            <label for="coordination_radio_input_3" class="form-check-label">
              külső vállalkozó cég</label
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group mb-3" v-if="coordination == 2">
              <label class="form-label"
                >Összehangolást végző munkavállaló:</label
              >
              <v-select
                v-if="users"
                v-model="coordination_user_id"
                :options="users.filter((u) => [3, 5].includes(u.role_id))"
                :reduce="(option) => option.id"
                label="name"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!coordination_user_id"
                    v-bind="attributes"
                    v-on="events"
                    :placeholder="!coordination_user_id ? 'Válassz' : ''"
                  />
                </template>
              </v-select>
            </div>
            <div class="form-group mb-3" v-if="coordination == 3">
              <label class="form-label"
                >Összehangolást végző vállalkozó cég:</label
              >
              <v-select
                v-if="partners"
                v-model="coordination_partner_id"
                :options="partners"
                :reduce="(option) => option.id"
                label="name"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!coordination_partner_id"
                    v-bind="attributes"
                    v-on="events"
                    :placeholder="!coordination_partner_id ? 'Válassz' : ''"
                  />
                </template>
              </v-select>
            </div>
            <div
              class="form-group mb-3"
              v-if="coordination && coordination_partner_id"
            >
              <label class="form-label"
                >Összehangolást végző vállalkozó cég vezetője:</label
              >
              <v-select
                v-if="third_party_partner_workers"
                v-model="coordination_user_id"
                :options="third_party_partner_workers"
                :reduce="(option) => option.id"
                label="name"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!coordination_user_id"
                    v-bind="attributes"
                    v-on="events"
                    :placeholder="!coordination_user_id ? 'Válassz' : ''"
                  />
                </template>
              </v-select>
              <Loading
                title="vállalkozó cég munkavállalóinak betöltése"
                v-else
              ></Loading>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import User from "../apis/User";
import CoordinationExplanation from "./CoordinationExplanation.vue";
import Loading from "./Loading.vue";
export default {
  components: {
    Loading,
    CoordinationExplanation,
  },
  props: ["partners", "users"],
  data() {
    return {
      coordination: 1,
      coordination_partner_id: null,
      coordination_user_id: null,
      third_party_partner_workers: false,
    };
  },
  watch: {
    coordination() {
      this.coordination_partner_id = null;
      this.coordination_user_id = null;
      this.emitChange();
    },
    coordination_partner_id: function (val) {
      if (val) {
        this.third_party_partner_workers = false;
        User.getRole(6).then((response) => {
          if (response.data.length != 0) {
            this.third_party_partner_workers = response.data.filter(
              (item) => item.partner_id == val
            );
            this.third_party_partner_workers.forEach((tppw) => {
              this.$set(
                tppw,
                "name",
                tppw.last_name +
                  " " +
                  tppw.first_name +
                  (tppw.name_extension != null
                    ? " " + tppw.name_extension
                    : "") +
                  (tppw.partner_id != null
                    ? " (" + tppw.partner_name + ")"
                    : "")
              );
            });
          } else {
            this.third_party_partner_workers = response.data;
          }
        });
      }
      this.emitChange();
    },
    coordination_user_id() {
      this.emitChange();
    },
  },
  methods: {
    emitChange() {
      this.$emit("change", {
        coordination: this.coordination,
        coordination_partner_id: this.coordination_partner_id,
        coordination_user_id: this.coordination_user_id,
      });
    },
  },
};
</script>
